import React from 'react';
import './Footer.css';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <footer className='footer-container'>
      <div className='footer-inner'>

        <Link to='/' className='footer-brand-link'>
          <img src={require('../images/V-2.png')} alt='' />
          <span className='footer-wordmark'>Van Vlimmeren Feestverhuur</span>
        </Link>
        <p className='footer-tagline'>&ldquo;Uw feest, onze zorg&rdquo;</p>

        <div className='footer-rule' aria-hidden='true'></div>

        <nav className='footer-nav' aria-label='Footer navigatie'>
          <Link to='/'>Home</Link>
          <span className='footer-sep' aria-hidden='true'>·</span>
          <Link to='/producten'>Producten</Link>
          <span className='footer-sep' aria-hidden='true'>·</span>
          <Link to='/portfolio'>Portfolio</Link>
          <span className='footer-sep' aria-hidden='true'>·</span>
          <Link to='/prijslijst'>Prijslijst</Link>
          <span className='footer-sep' aria-hidden='true'>·</span>
          <Link to='/bestellen'>Bestellen</Link>
          <span className='footer-sep' aria-hidden='true'>·</span>
          <Link to='/contact'>Contact</Link>
        </nav>

        <div className='footer-contact'>
          <a
            href='http://maps.google.nl/?q=Berkenhof%204,%204711RS%20Sint%20Willebrord'
            target='_blank'
            rel='noopener noreferrer'>
            Berkenhof 4, 4711RS Sint Willebrord
          </a>
          <span className='footer-contact-row'>
            <a href='mailto:info@vanvlimmerenfeestverhuur.nl'>
              info@vanvlimmerenfeestverhuur.nl
            </a>
            <span className='footer-sep' aria-hidden='true'>·</span>
            <a href='tel:0618218292'>06-18218292</a>
          </span>
        </div>

        <div className='footer-social'>
          {/* Plain anchors: router Links must not handle external URLs. */}
          <a
            className='footer-social-link'
            href='https://www.facebook.com/profile.php?id=61569594416814'
            target='_blank'
            rel='noopener noreferrer'
            aria-label='Facebook'>
            <i className='fab fa-facebook-f' />
          </a>
          <a
            className='footer-social-link'
            href='https://www.instagram.com/vanvlimmerenfeestverhuur/'
            target='_blank'
            rel='noopener noreferrer'
            aria-label='Instagram'>
            <i className='fab fa-instagram' />
          </a>
        </div>

        <div className='footer-meta'>
          <span>KVK 91703921</span>
          <span className='footer-meta-sep' aria-hidden='true'>·</span>
          <span>© 2026 Van Vlimmeren Feestverhuur</span>
        </div>

        <p className='footer-credit'>
          {/* Plain anchor: router Links must not handle external URLs. */}
          Website door{' '}
          <a
            href='https://aspectstudios.org/nl'
            target='_blank'
            rel='noopener noreferrer'>
            Aspect Studios
          </a>
        </p>

      </div>
    </footer>
  );
}

export default Footer;
